import { GetApp } from '@mui/icons-material';
import CancelIcon from '@mui/icons-material/Cancel';
import { Button, Dialog, DialogActions, DialogTitle, Tooltip } from '@mui/material';
import { action, computed, makeObservable, observable, reaction, runInAction } from 'mobx';
import { inject, observer } from 'mobx-react';
import { Fragment } from 'react';
import ErrorUtil from '../../util/ErrorUtil';
import NumeroProcesso from '../NumeroProcesso';
import PainelFiltros from '../PainelFiltros';
import ReactComponent from '../ReactComponent';
import FiltroRapido from './FiltroRapido';
import OperacoesEmLoteSelecionar from './OperacoesEmLoteSelecionar';
import PainelProcessosOperacoesEmLote from './PainelProcessosOperacoesEmLote';

class ImportarSalaSessaoLote extends ReactComponent {
    dialogOpen = false;

    constructor(props) {
        super(props);

        makeObservable(this, {
            dialogOpen: observable,
            handleClickIcone: action,
            handleCloseDialog: action,
            processos: computed,
            processosSelecionados: computed,
            limparProcessoPesquisa: action,
            mensagemLoteSemProcessos: computed,
            handleClickImportar: action,
            renderConteudoDialog: computed
        });

        this.createReaction(
            reaction(
                () => this.dialogOpen,
                () => this.limparProcessoPesquisa()
            )
        );
    }

    handleClickIcone = () => {
        this.dialogOpen = true;
    };

    handleCloseDialog = () => {
        this.dialogOpen = false;
    };

    get processos() {
        return (this.store.processosFiltrados || [])
            .filter((registro) => registro.necessitaImportacaoSalaSessao)
            .filter((registro) => this.filtrarProcessoPeloNumero(registro));
    }

    get processosSelecionados() {
        return this.processosSelecionaveis.filter((registro) => this.store.isCheckedOperacoesEmLote(registro));
    }

    get processosSelecionaveis() {
        return this.processos;
    }

    limparProcessoPesquisa = () => {
        this.processoPesquisa = { numero: '', digito: '', ano: '', orgao: '', regional: '', vara: '' };
    };

    get mensagemLoteSemProcessos() {
        return 'Não há processos pendentes de importação para a sala de sessão' + this.complementoMensagemFiltrando;
    }

    handleClickImportar = async () => {
        if (this.processosSelecionados.length > 0) {
            let qtdTotalProcessos = this.processosSelecionados.length;
            await this.store.processarLote({
                titulo: 'Importando para sala de sessão',
                qtdTotalProcessos: qtdTotalProcessos,
                lotesProcessos: this.processosSelecionados,
                funcaoOperacao: (registro) => this.importarSalaSessao(registro, qtdTotalProcessos)
            });
            if (qtdTotalProcessos >= 10) {
                this.sessaoStore.recarregarListaProcessos(true, true);
            }
        } else {
            this.mensagemStore.abrirMensagemAlerta('Selecione um ou mais processos');
        }
    };

    importarSalaSessao = async (registro, qtdTotalProcessos) => {
        const resultado = await this.sessaoService.importarSalaSessao(registro);

        if (resultado && !ErrorUtil.isResultadoErro(resultado)) {
            if (qtdTotalProcessos < 10) {
                this.sessaoStore.recarregarProcesso(registro, true);
            }
            runInAction(() => (registro.necessitaImportacaoSalaSessao = false));
        }

        this.store.incrementarProgressoLote();

        return resultado;
    };

    render() {
        if (!this.parametroStore.isOrgaoTST) {
            return null;
        }
        return (
            <div>
                <div
                    style={{ marginRight: '10px' }}
                    className="corBotao"
                >
                    <Tooltip
                        title={'Importar processos para sala de sessão em lote'}
                        placement="top-start"
                    >
                        <GetApp
                            onClick={this.handleClickIcone}
                            style={{ cursor: 'pointer', width: '24px', height: '24px' }}
                        />
                    </Tooltip>
                </div>
                {this.dialogOpen && (
                    <Dialog
                        fullWidth
                        maxWidth="xl"
                        onClose={this.handleCloseDialog}
                        open={this.dialogOpen}
                        PaperProps={{ style: { height: '100%' } }}
                    >
                        <DialogTitle
                            id="simple-dialog-title"
                            style={{ padding: '16px 24px 0px' }}
                        >
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <div
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        flexWrap: 'wrap',
                                        flexGrow: 1
                                    }}
                                >
                                    <h4 style={{ margin: '0px' }}>Importar processos para sala de sessão em lote</h4>
                                    <div style={{ margin: '0px 10px' }}>
                                        <NumeroProcesso
                                            dense
                                            tooltip="Número do processo a ser pesquisado na listagem"
                                            callbackOnChange={this.callbackNumeroProcesso}
                                            clickLimpar={this.limparProcessoPesquisa}
                                        />
                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <div
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                margin: '10px',
                                                paddingTop: '5px'
                                            }}
                                        >
                                            <PainelFiltros />
                                        </div>
                                        <FiltroRapido id="filtroRapidoImportarSalaSessaoLote" />
                                    </div>
                                </div>
                            </div>
                        </DialogTitle>
                        {this.renderConteudoDialog}
                        <DialogActions>
                            <Button
                                onClick={this.handleCloseDialog}
                                color="secondary"
                                variant="outlined"
                                endIcon={<CancelIcon />}
                            >
                                Fechar
                            </Button>
                            <Button
                                onClick={this.handleClickImportar}
                                color="primary"
                                variant="outlined"
                                endIcon={<GetApp />}
                            >
                                Importar
                            </Button>
                        </DialogActions>
                    </Dialog>
                )}
            </div>
        );
    }

    get renderConteudoDialog() {
        return (
            <Fragment>
                <OperacoesEmLoteSelecionar
                    processosSelecionaveis={this.processosSelecionaveis}
                    processos={this.processos}
                />
                <PainelProcessosOperacoesEmLote
                    processos={this.processos}
                    mensagemLoteSemProcessos={this.mensagemLoteSemProcessos}
                />
            </Fragment>
        );
    }
}

export default inject('stores')(observer(ImportarSalaSessaoLote));
